import { meUser as meApi } from '@api/generated/sdk.gen';

import type { UserResponse } from '@api/generated/types.gen';

/**
 * Единый кэш профиля текущего пользователя.
 *
 * Один сетевой запрос `/api/users/me` обслуживает все хуки Refine
 * (`getIdentity`, `getPermissions`) и `accessControlProvider.can`.
 * До этого было два независимых кэша в разных модулях, что приводило
 * к двойному /me на логине и к рассинхрону инвалидации.
 *
 * Кэширует промис, а не результат, — параллельные вызовы не делают
 * дублирующих запросов.
 */
let inflight: Promise<UserResponse | null> | null = null;
let cached: UserResponse | null = null;

/**
 * Возвращает закэшированный или свежий профиль.
 *
 * @returns профиль или `null`, если запрос упал (например, токена нет)
 */
export function loadIdentity(): Promise<UserResponse | null> {
  if (cached) return Promise.resolve(cached);
  if (inflight) return inflight;
  inflight = meApi()
    .then((res) => {
      cached = res.data ?? null;
      return cached;
    })
    .catch(() => {
      cached = null;
      return null;
    })
    .finally(() => {
      inflight = null;
    });
  return inflight;
}

/**
 * Сбрасывает кэш. Вызывается на login/logout, чтобы при следующем
 * обращении подтянулись свежие данные (включая permissions).
 */
export function resetIdentityCache(): void {
  cached = null;
  inflight = null;
}
